<form *ngIf="materialFormGroup" [formGroup]="materialFormGroup">
    <p-card class="p-3" header="Datos generales">
        <div class="grid">
            <div class="col-6 input-field">
                <label for="name">Nombre *</label>
                <input pInputText formControlName="name" d-form-field-error />
            </div>
            <div class="col-4 input-field">
                <label for="iconClass">Icono</label>
                <div class="flex align-items-center gap-2">
                    <input pInputText formControlName="iconClass" d-form-field-error class="w-full"
                        placeholder="pi pi-box" />
                    <i *ngIf="materialFormGroup.value.iconClass" [ngClass]="materialFormGroup.value.iconClass"></i>
                </div>
                <small class="text-color-secondary">Clase de PrimeIcons, p. ej. <b>pi pi-hammer</b><br>Clase de FontAwesome, p. ej. <b>fa fa-paint-roller</b></small>
            </div>
            <div class="col-2 input-field">
                <label for="active" class="mr-1">Activo</label>
                <div class="flex h-full">
                  <p-inputSwitch id="active" name="active" formControlName="active" d-form-field-error></p-inputSwitch>
                </div>
              </div>
        </div>

        <div class="mt-4 flex gap-2 justify-content-end">
            <p-button label="Eliminar" *ngIf="allowDelete" icon="pi pi-trash" styleClass="p-button-danger" (click)="delete()"></p-button>
            <div class="flex-grow-1"></div>
            <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
            <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
                (click)="save()"></p-button>
        </div>
    </p-card>
</form>
<p-confirmDialog></p-confirmDialog>
